var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "$";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      ),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

$(document).on("click", ".common-button-qty-toggle", function (e) {
  $(this)
    .parents(".common-button-qty-toggle-wrapper")
    .find(".common-qty-input")
    .val(1);
  $(this).addClass("hidden");
  $(this).next(".js-qty-toggle").removeClass("hidden");
  let id = $(this).parents(".common-button-qty-toggle-wrapper").attr("data-product-id");
  addToCart(id, 1);
});

function addToCart(id, qty) {
  $.ajax({
    url: "/cart/add.js",
    method: "POST",
    data: {
      id: id,
      quantity: qty,
    },
    dataType: "JSON",
    success: (data) => {
      $.get('/cart.json', function (cart) {
        fetchCartandUpdateGrid(cart.items, cart);
        updateCartDrawer();
      })
    },
  });
}

$("body").on("click", ".js-qty-toggle .js-plus", function (e) {
  e.preventDefault();
  let currentEM = $(e.target);
  $(currentEM).closest(".js-plus").addClass("is-processing");
  $(currentEM).closest(".js-minus").addClass("is-processing");
  let quantityInput = $(this).prev(".js-quantity");
  let quantityValue = parseInt(quantityInput.val());
  let id = $(this).parents(".common-button-qty-toggle-wrapper").attr("data-product-id");
  quantityInput
    .val(quantityValue + 1)
    .change();
  updateCart(id, parseInt(quantityValue + 1), currentEM);
});

$("body").on("click", ".js-qty-toggle .js-minus", function (e) {
  e.preventDefault();
  let currentEM = $(e.target);
  $(currentEM).closest(".js-plus").addClass("is-processing");
  $(currentEM).closest(".js-minus").addClass("is-processing");
  let quantityInput = $(this).next(".js-quantity");
  let quantityValue = parseInt(quantityInput.val());
  let id = $(this).parents(".common-button-qty-toggle-wrapper").attr("data-product-id");
  if (quantityValue > 1) {
    quantityInput.val(quantityValue - 1).change();
  } else {
    quantityInput.val(quantityValue - 1).change();;
    $(this)
      .parents()
      .closest(".common-button-qty-toggle-wrapper")
      .find(".common-button-qty-toggle")
      .removeClass("hidden");
    $(this)
      .parents()
      .closest(".common-button-qty-toggle-wrapper")
      .find(".js-qty-toggle")
      .addClass("hidden");
  }
  updateCart(id, parseInt(quantityValue - 1), currentEM);
});

function updateCart(id, qty, currentEM) {
  let item = {
    id: id,
    quantity: parseInt(qty)
  };
  $.ajax({
    url: "/cart/change.js",
    method: "POST",
    data: item,
    dataType: "JSON",
    success: (data) => {
      if ((currentEM != null) && (typeof currentEM != "undefined")) {
        $(currentEM).closest(".js-plus").removeClass("is-processing");
        $(currentEM).closest(".js-minus").removeClass("is-processing");
      }
      $.get('/cart.json', function (cart) {
        fetchCartandUpdateGrid(cart.items, cart);
        updateCartDrawer();
      })
    },
  });
}

function updateCartDrawer() {
  fetch('/cart?view=custom-drawer')
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      let products_cart_count = doc.querySelector('#total_products').textContent;
      $('.custom-cart__flyout-items').html(html);
      $(".custom-cart__flyout-subtotal-final-amount").text(doc.querySelector('#total_price').textContent);
      if (doc.querySelector('#total_compare_at_price').textContent != '') {
        $('.custom-cart__flyout-subtotal-amount').addClass('sale-price');
      } else {
        $('.custom-cart__flyout-subtotal-amount').removeClass('sale-price');
      }
      if (products_cart_count > 0) {
        $('.custom-cart__flyout-empty-cart').hide();
        $('.custom-cart__flyout-filled-cart').show();
        $('.custom-cart__flyout-footer').show();
        $('.filled-cart-count').text(products_cart_count);
        $('.mini-cart-count-dot').show();
      } else {
        $('.custom-cart__flyout-filled-cart').hide();
        $('.custom-cart__flyout-empty-cart').show();
        $('.custom-cart__flyout-footer').hide();
        $('.filled-cart-count').text(products_cart_count);
        $('.mini-cart-count-dot').hide();
      }
      $(".custom-cart__flyout-subtotal-compare-amount").text(doc.querySelector('#total_compare_at_price').textContent);

      /** Cart Drawer update **/
      var cartTotalPrice = doc.querySelector('#total_price_without_money').textContent;
      var cartThresholdPrice = $('.custom-cart__progress-bar-meter-fill').attr('data-cartthresholdvalue');
      var cartRemainingPrice = cartThresholdPrice - cartTotalPrice;

      var cartProgressValue = (cartTotalPrice * 100) / cartThresholdPrice;
      $(".custom-cart__progress-bar-meter-fill").css("width", `${cartProgressValue}%`);
      if (products_cart_count > 0) {
        $('.custom-cart__progress-bar-meter').removeClass('no-progress').addClass('has-progress');
      } else {
        $('.custom-cart__progress-bar-meter').removeClass('has-progress').addClass('no-progress');
      }

      if (cartRemainingPrice > 0) {
        var cartProgressText = $(".custom-cart__progress-away")
          .attr("data-text")
          .replace("@price", `${Shopify.formatMoney(
            cartRemainingPrice,
            $("body").attr("data-money")
          )}`);
        $(".custom-cart__progress-away").html(cartProgressText);
        $('.custom-cart__progress-away').show();
        $('.custom-cart__progress-reach').hide();
      } else {
        $('.custom-cart__progress-away').hide();
        $('.custom-cart__progress-reach').show();
        $(".custom-cart__progress-bar-meter-fill").css("width", `100%`);
      }

    })
    .catch(error => {
      console.error('Error fetching the custom cart:', error);
    });
}

$('body').on('click', '.common-qty, .common-button-qty-toggle', function(e) {
  if($(window).width() < 768) {
    $('.common-qty').removeClass('active');
    $(this).addClass('active');
  }
});

window.addEventListener("minicart-custom", function () {
  $.get('/cart.json', function (cart) {
    fetchCartandUpdateGrid(cart.items, cart);
  })
});

async function fetchCartandUpdateGrid(cartItems, cart) {
  var cartCount = 0;
  var totalPrice = 0;
  var totalDiscountedPrice = 0;

  $('.product-addToCart').removeAttr('disabled')

  $('.product-list__item--new').removeClass('active');
  $('.product-list__item--new .common-button-qty-toggle').removeClass('hidden');
  $('.product-list__item--new .common-qty').addClass('hidden');
  $('.sale-sidebar-filled-cart').empty();
  $('.mobile-sticky-products-wrapper').empty();
  for (var i = 0; i < 30; i++) {
    $('.mobile-sticky-products-wrapper').append(`<div class="mobile-sticky-product blank"><h4>+</h4></div>`);
  }

  var quantityMap = {};

  cartItems.forEach(function(item) {
    if (!quantityMap[item.id]) {
      quantityMap[item.id] = 0;
    }
    quantityMap[item.id] += item.quantity;
  });

  for (const item of cartItems) {
    var totalQty = quantityMap[item.id];

    if ($('.product-list__item--new[data-id="' + item.id + '"]').length > 0) {
      $('.product-list__item--new[data-id="' + item.id + '"]').addClass('active');
      $('.product-list__item--new[data-id="' + item.id + '"] .common-qty-input').val(item.quantity);
      if(item.quantity > 1) {
        $('.product-list__item--new[data-id="' + item.id + '"] .common-qty .common-qty-minus-one-qty').addClass('hidden');
        $('.product-list__item--new[data-id="' + item.id + '"] .common-qty .common-qty-minus-more-qty').removeClass('hidden');
      } else {
        $('.product-list__item--new[data-id="' + item.id + '"] .common-qty .common-qty-minus-one-qty').removeClass('hidden');
        $('.product-list__item--new[data-id="' + item.id + '"] .common-qty .common-qty-minus-more-qty').addClass('hidden');
      }
      $('.product-list__item--new[data-id="' + item.id + '"] .common-button-qty-toggle').addClass('hidden');
      $('.product-list__item--new[data-id="' + item.id + '"] .common-qty').removeClass('hidden');

      var $matchingProduct = $('.product-list__item--new[data-id="' + item.id + '"]');

      var itemComparePrice = 0;

      if ($matchingProduct.length > 0) {
        await fetch(`/products/${item.handle}.json`)
          .then(res => res.json())
          .then(data => {
            itemComparePrice = parseFloat(data?.product?.variants?.find(v => v.id == item.variant_id)?.compare_at_price || "0")
          })
          .catch(err => console.error(err));

        item.itemComparePrice = itemComparePrice * item.quantity
        $('.sale-sidebar-empty-cart').addClass('hidden');

        addItemInSidebar(item);

        var totalComparePrice = item.original_price > (itemComparePrice * 100) ? item.original_price : (itemComparePrice * 100)

        totalPrice += item.quantity * totalComparePrice;

        console.log(itemComparePrice, 'itemComparePrice', totalComparePrice)

        totalDiscountedPrice += item.quantity * item.discounted_price;
        
        if (totalQty > 1) {
          $matchingProduct.find('.b20g10-qty-minus-one-qty').addClass('hidden');
          $matchingProduct.find('.b20g10-qty-minus-more-qty').removeClass('hidden');
        } else {
          $matchingProduct.find('.b20g10-qty-minus-one-qty').removeClass('hidden');
          $matchingProduct.find('.b20g10-qty-minus-more-qty').addClass('hidden');
        }
        cartCount += totalQty;
        
      }      
    }
  };

  if(cartItems.length != 0){
    $('.sale-sidebar-empty-cart').addClass('hidden');
    $('.mobile-sticky-products').removeClass('hidden');
    $('.sale-collection-total-content').removeClass('hidden');
  } else {
    $('.sale-sidebar-empty-cart').removeClass('hidden');
    $('.mobile-sticky-products').addClass('hidden');
    $('.sale-collection-total-content').addClass('hidden');
  }

  $('.sale-collection-total-amount').text(`${Shopify.formatMoney(
    totalDiscountedPrice,
    $("body").attr("data-money")
  )}`);
  $('.sale-collection-total-compare-amount').text(`${Shopify.formatMoney(
    totalPrice,
    $("body").attr("data-money")
  )}`);

  $('.sale-collection-total-saving').text(`${Shopify.formatMoney(
    totalPrice - totalDiscountedPrice,
    $("body").attr("data-money")
  )}`);

  if(totalPrice - totalDiscountedPrice > 0){
    $('.subtotal-wrapper, .saving-wrapper').removeClass('hidden')
  } else {
    $('.subtotal-wrapper, .saving-wrapper').addClass('hidden')
  }

  $('.sale-collection-product-counts').text(cartCount);
}

async function addItemInSidebar(item) {
  console.log(item, 'itemitem')
  const variantId = item.variant_id;
  const imageUrl = item.image ? item.image.replace(/(\?|$)/, '?width=110$1') : '';
  const productUrl = item.url + '?variant=' + variantId;
  const itemKey = item.key;
  const quantity = item.quantity;
  const price = (item.final_line_price / 100).toFixed(2); // final price
  const compareAtPrice = item.original_line_price > item.final_line_price
    ? (item.original_line_price / 100).toFixed(2)
    : null;

  const itemComparePrice = item.itemComparePrice || 0;


  const $item = $(`
    <div aria-label="product" class="custom-cart__flyout-item">
      <div class="custom-cart__flyout-item-media">
        <a href="${productUrl}" tabindex="-1">
          <img src="${imageUrl}" width="40" height="110" alt="${item.product_title}">
        </a>
      </div>
      <div class="custom-cart__flyout-item-info">
        <a role="heading" aria-level="5" href="${productUrl}" tabindex="0" class="custom-cart__flyout-item-product-title">${item.product_title}</a>
        <div tabindex="0" class="custom-cart__flyout-item-variant-title">${item.variant_title || ""}</div>
        <div class="custom-cart__flyout-item-properties"></div>

        <a class="custom-cart__flyout-item-remove sidebar-b20g10-qty-remove" data-item_quantity="${quantity}" data-item_name="${item.product_title}" data-item_id="${variantId}" data-item_price="${(item.final_price / 100).toFixed(2)}" data-item_sku="${item.sku}" data-item_variant="${item.variant_title}" data-final_price="${price}" href="#"
           data-key="${itemKey}">
          <svg width="21" height="25" viewBox="0 0 21 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_1_756)">
            <path d="M18.7135 5.1996V23.2295C18.7135 24.0067 17.3433 25.1008 16.5132 24.9933L4.32824 24.9844C3.5497 25.028 2.28959 23.9563 2.28959 23.2306V5.1996H0.657972C0.379347 5.1996 0.0216079 4.76957 0.00211566 4.49408C-0.0368688 3.94535 0.469929 3.72361 0.942329 3.68778C2.17378 3.59483 3.50957 3.78409 4.75134 3.66314L6.13185 0.37184C6.2981 0.141146 6.62374 0.073954 6.89319 0.0537964C9.23799 -0.117544 11.7984 0.188181 14.1661 0.0537964C14.4424 0.0784335 14.7887 0.183701 14.9114 0.444631L16.2518 3.66314C17.4935 3.78409 18.8282 3.59483 20.0608 3.68778C20.5355 3.72361 21.0239 3.94983 20.9987 4.49632C20.9861 4.77069 20.618 5.1996 20.3451 5.1996H18.7146H18.7135ZM6.40932 3.69002H14.5926L13.7567 1.56226L7.30482 1.57458L6.40818 3.69002H6.40932ZM17.2252 5.1996H3.77673V22.9496C3.77673 23.1063 4.06223 23.4121 4.23193 23.4546L16.6255 23.4815C16.8354 23.5095 17.2252 23.1086 17.2252 22.9496V5.1996Z" fill="#333333"/>
            <path d="M10.5017 8.13812C11.0154 8.13812 11.2229 8.52448 11.2734 8.97467C11.0899 12.444 11.5188 16.1575 11.2768 19.5989C11.2413 20.1073 11.1174 20.5788 10.5017 20.5788C9.88599 20.5788 9.76216 20.1062 9.72661 19.5989C9.48353 16.1575 9.91236 12.4451 9.73005 8.97467C9.7484 8.51664 9.99606 8.13812 10.5017 8.13812Z" fill="#333333"/>
            <path d="M6.50712 8.17396C7.02539 8.0575 7.47256 8.33299 7.49893 8.8582V19.9315C7.3751 20.693 6.36839 20.8195 6.05307 20.1107L6.0095 8.80445C6.00033 8.56704 6.2778 8.22548 6.50827 8.17396H6.50712Z" fill="#333333"/>
            <path d="M14.0047 8.17396C14.5229 8.0575 14.9701 8.33299 14.9965 8.8582V19.9315C14.8727 20.693 13.8659 20.8195 13.5506 20.1107L13.5071 8.80445C13.4979 8.56704 13.7754 8.22548 14.0058 8.17396H14.0047Z" fill="#333333"/>
            </g>
            <defs>
            <clipPath id="clip0_1_756">
            <rect width="21" height="25" fill="white"/>
            </clipPath>
            </defs>
          </svg>
        </a>

        <div class="custom-cart__flyout-item-quantity">
          <div class="custom-cart__flyout-item-quantity-widget">
            <button type="button" class="custom-cart__flyout-item-quantity-widget-button sidebar-b20g10-qty-minus"
              data-action="decrease" data-key="${itemKey}">
              −
            </button>
            <input class="custom-cart__flyout-item-quantity-widget-label sidebar-b20g10-qty-input"
              name="quantity" type="number" min="0" data-id="${variantId}" value="${quantity}"
              data-key="${itemKey}">
            <button type="button" class="custom-cart__flyout-item-quantity-widget-button sidebar-b20g10-qty-plus"
              data-action="increase" data-key="${itemKey}">
              +
            </button>
          </div>
        </div>

        <div class="custom-cart__flyout-item-price">
          <div>
            <span class="custom-money">
              <span tabindex="0">£${price}</span>
            </span>
            ${itemComparePrice > 0 ? `
              <span class="custom-money compare-at">
                <span tabindex="0">£${itemComparePrice?.toFixed(2)}</span>
              </span>` : ''}
          </div>
        </div>
      </div>
    </div>
  `);

  // Append to cart container
  $('.sale-sidebar-filled-cart').append($item);

  for(i = 0; i < quantity; i++) {
    var $mobileItem = $(`<div class="mobile-sticky-product-item">
                          <div class="mobile-sticky-product-data">
                              <img src="${imageUrl}">
                              <a href="javascript:;" class="close-icon" data-key="${itemKey}" data-id="${variantId}" data-qty="${quantity}">
                              <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 329.269 329" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g transform="matrix(0.75,0,0,0.75,41.15877950191498,41.19175672531128)"><path d="M194.8 164.77 323.013 36.555c8.343-8.34 8.343-21.825 0-30.164-8.34-8.34-21.825-8.34-30.164 0L164.633 134.605 36.422 6.391c-8.344-8.34-21.824-8.34-30.164 0-8.344 8.34-8.344 21.824 0 30.164l128.21 128.215L6.259 292.984c-8.344 8.34-8.344 21.825 0 30.164a21.266 21.266 0 0 0 15.082 6.25c5.46 0 10.922-2.09 15.082-6.25l128.21-128.214 128.216 128.214a21.273 21.273 0 0 0 15.082 6.25c5.46 0 10.922-2.09 15.082-6.25 8.343-8.34 8.343-21.824 0-30.164zm0 0" fill="#ffffff" opacity="1" data-original="#000000"></path></g></svg> 
                              </a>
                          </div>
                          <div class="mobile-sticky-product-title">
                              <h5>${item.product_title}</h5>
                          </div>
                          </div>
    
    `);
  
    var $target = $('.mobile-sticky-product.blank').first();
    $target.replaceWith($mobileItem);
  }
}

$('body').on('click', '.sidebar-b20g10-qty-remove', function(e) {
  e.preventDefault();
  var qty = 0;
  var var_id = $(this).attr('data-key');
  let updates = {};
  updates[var_id] = qty;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "remove_from_cart",
    ecommerce: {
      currency: "GBP",
      value: $(this).attr('data-final_price'),
      items: [{
        item_name: $(this).attr('data-item_name'),
        item_id: $(this).attr('data-item_id'),
        item_sku: $(this).attr('data-item_sku'),
        price: $(this).attr('data-item_price'),
        quantity: $(this).attr('data-item_quantity'),
        item_variant: $(this).attr('data-item_variant')
      }]
    }
  });

  $.ajax({
    url: "/cart/update.js",
    method: "POST",
    data: {
      updates: updates
    },
    dataType: "json",
    success: function (cart) {
      $.get('/cart.json', function (cart) {
        fetchCartandUpdateGrid(cart.items, cart);
        updateCartDrawer();
      })
    }
  });
});

$('body').on('click', '.sidebar-b20g10-qty-plus', function(e) {
  e.preventDefault();
  var qty = $(this).closest('.custom-cart__flyout-item-quantity-widget').find('.custom-cart__flyout-item-quantity-widget-label').val();
  qty = parseInt(qty) + 1;
  var var_id = $(this).attr('data-key');
  let updates = {};
  updates[var_id] = qty;

  $.ajax({
    url: "/cart/update.js",
    method: "POST",
    data: {
      updates: updates
    },
    dataType: "json",
    success: function (cart) {
      $.get('/cart.json', function (cart) {
        fetchCartandUpdateGrid(cart.items, cart);
        updateCartDrawer();
      })
    }
  });
});

$('body').on('click', '.sidebar-b20g10-qty-minus', function(e) {
  e.preventDefault();
  var qty = $(this).closest('.custom-cart__flyout-item-quantity-widget').find('.custom-cart__flyout-item-quantity-widget-label').val();
  qty = parseInt(qty) - 1;
  var var_id = $(this).attr('data-key');
  let updates = {};
  updates[var_id] = qty;

  $.ajax({
    url: "/cart/update.js",
    method: "POST",
    data: {
      updates: updates
    },
    dataType: "json",
    success: function (cart) {
      $.get('/cart.json', function (cart) {
        fetchCartandUpdateGrid(cart.items, cart);
        updateCartDrawer();
      })
    }
  });
});

$('body').on('input', '.sidebar-b20g10-qty-input', function(e) {
  e.preventDefault();
  var var_id = $(this).attr('data-key');
  var qty = $(this).val();
  let updates = {};
  updates[var_id] = qty;
  $.ajax({
    url: "/cart/update.js",
    method: "POST",
    data: {
      updates: updates
    },
    dataType: "json",
    success: function (cart) {
      $.get('/cart.json', function (cart) {
        fetchCartandUpdateGrid(cart.items, cart);
        updateCartDrawer();
      })
    }
  });
});

$('body').on('click', '.mobile-sticky-product-data .close-icon', function(e) {
  e.preventDefault();
  var var_id = $(this).attr('data-id');
  var var_key = $(this).attr('data-key');
  var qty = $(`.product-list__item--new[data-id="${var_id}"]:first`).find(".product-list__qty .common-qty-input").val() - 1;

  let updates = {};
  updates[var_key] = qty;

  $.ajax({
    url: "/cart/update.js",
    method: "POST",
    data: {
      updates: updates
    },
    dataType: "json",
    success: function (cart) {
      $.get('/cart.json', function (cart) {
        fetchCartandUpdateGrid(cart.items, cart);
        updateCartDrawer();
      })
    }
  });

});

$('body').on('click', '.sale-collection-final-btn', function(e) {
    if($(this).attr('href') == '#') {
        e.preventDefault();
        window.dispatchEvent(new CustomEvent("minicart"));
    }
});